import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

const BriefingSheet = ({ data }) => {
    const { general, alt, metar, weight, fuel, compFreq, mel, cdl, extra, efb, creator } = data;

    const { dDate, flt, reg, acTyp, dIcao, etd, aIcao, bay, fic, adc, capName, foName } = general;
    const { takeOff, dest1, dest2 } = alt;
    const { dep, arr, takeOffAlt, destAlt1, destAlt2, } = metar;
    const { stTow, stLw, stZfw, otow, olw, ezfw, } = weight;
    const { trip, minDisp, destHold, extra: extraFuel, ramp } = fuel;
    const { vhf, hfDay, hfNight, } = compFreq;
    const { remark, closure, permit } = extra;
    const { aerodoc, opt, ddg, jeppesen, iqrh } = efb;
    const { name, sign } = creator;

    const melcdl = (mel.length || cdl.length) ? `${mel.join('\n')}\n${cdl.join('\n')}` : 'NIL';

    return <>
        <style dangerouslySetInnerHTML={{
            __html: `
            * {
                box-sizing: border-box;
                -moz-box-sizing: border-box;
            }
            html,
            body,
            h1,
            h2,
            h3,
            h4,
            h5,
            h6,
            table,
            thead,
            tbody,
            tfoot,
            tr,
            th,
            td,
            p {
                padding: 0;
                margin: 0;
            }
            .wrapper {
                line-height: 1;
                background-color: #FFFFFF;
            }
            // .page {
            //     width: 21cm;
            //     min-height: 29.7cm;
            //     padding: 1cm;
            //     margin: 1cm auto;
            //     border: 1px #D3D3D3 solid;
            //     border-radius: 5px;
            //     background: white;
            //     box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
            // }
            @page {
                size: A4;
                margin: 0;
            }
            @media print {
                .page {
                    margin: 0;
                    border: initial;
                    border-radius: initial;
                    width: initial;
                    min-height: initial;
                    box-shadow: initial;
                    background: initial;
                }
            }
            .page table {
                font: 9pt "Verdana";
            }
            ul,
            ol {
                margin: 0;
            }
            table {
                border-collapse: collapse;
                margin: auto;
            }
            table th,
            table td {
                border: solid 1px #343a40;
                padding: 0.25rem;
            }
            table th {
                -webkit-print-color-adjust: exact;
                background: #e4e4e4;
            }
            .align-top {
                vertical-align: top;
            }
            .align-bottom {
                vertical-align: bottom;
            }
            table.border-0>thead>tr>th,
            table.border-0>thead>tr>td,
            table.border-0>tbody>tr>th,
            table.border-0>tbody>tr>td,
            table.border-0>tfoot>tr>th,
            table.border-0>tfoot>tr>td {
                border: none;
            }
            .table-layout-fixed {
                table-layout: fixed;
            }
            .border-0 {
                border: none;
            }
            .text-center {
                text-align: center;
            }
            .text-left {
                text-align: left;
            }
            .text-right {
                text-align: right;
            }
            .h-100 {
                height: 100%;
            }
            .w-100 {
                width: 100%;
            }
            .w-80 {
                width: 80%;
            }
            .w-50 {
                width: 50%;
            }
            .w-30 {
                width: 30%;
            }
            .w-20 {
                width: 20%;
            }
            .p-0 {
                padding: 0;
            }
            .pt-0 {
                padding-top: 0;
            }
            .pb-0 {
                padding-bottom: 0;
            }
            .border {
                border: solid 1px #343a40;
            }
            .border-bottom {
                border-bottom: solid 1px #343a40 !important;
            }
            .border-top-0 {
                border-top: none !important;
            }
            .border-right-0 {
                border-right: none !important;
            }
            .border-bottom-0 {
                border-bottom: none !important;
            }
            .border-left-0 {
                border-left: none !important;
            }
            .text-nowrap {
                white-space: nowrap;
            }
            .text-prewrap {
                white-space: pre-wrap;
            }
            .bold {
                font-weight: bold;
            }
            .break-before {
                page-break-before: always;
            }
            .break-after {
                page-break-after: always;
            }
`}} />
        <div className='wrapper'>
            <div className="page break-after">
                <table className='w-100'>
                    <thead>
                        <tr>
                            <th colSpan="10" className="w-100">
                                <h2>Pre-Flight Briefing Sheet</h2>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td colSpan="5" className="w-50">
                                <table className="text-center border-0 table-layout-fixed">
                                    <tbody>
                                        <tr>
                                            <td colSpan="5" className="w-50">
                                                <img src="data:image/png;base64,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"
                                                    alt="SpiceJet Logo" />
                                            </td>
                                            <td colSpan="5" className="w-50">
                                                <h3>{acTyp}</h3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan="10" className="w-100 p-0">
                                                <table className="w-100 table-layout-fixed">
                                                    <tbody>
                                                        <tr>
                                                            <th>FIC</th>
                                                            <td>{fic}</td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr>
                                                            <th>ADC</th>
                                                            <td>{adc}</td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                            <td colSpan="5" className="w-50">
                                <table className="w-100">
                                    <tbody>
                                        <tr>
                                            <th colSpan="2" className="w-20 text-right">REQUEST</th>
                                            <td colSpan="8" className="w-80">POSITIVELY PASS DEPTARTURE &amp; ARRIVAL MSG &amp;
                                        ENROUTE POSITION REPORTS ON COMPANY HF/VHF.</td>
                                        </tr>
                                        <tr>
                                            <th colSpan="2" className="w-20 text-right">COMPANY FREQUENCIES</th>
                                            <td colSpan="8" className="w-80">VHF - {vhf}</td>
                                        </tr>
                                        <tr>
                                            <th colSpan="2" className="w-20 text-right">HF</th>
                                            <td colSpan="8" className="w-80">DAY - {hfDay}<br />NIGHT - {hfNight}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <th colSpan="2" className="w-20">ETA</th>
                            <td colSpan="3" className="w-30"></td>
                            <th colSpan="2" className="w-20">BAY NO</th>
                            <td colSpan="3" className="w-30">{bay}</td>
                        </tr>
                        <tr>
                            <td colSpan="10" className="w-100">
                                <table className="w-100 text-center table-layout-fixed">
                                    <tbody>
                                        <tr className="align-bottom text-nowrap">
                                            <th>DATE</th>
                                            <th>REG</th>
                                            <th>FLT NO</th>
                                            <th>ETD</th>
                                            <th>DEP STN</th>
                                            <th>DEST STN</th>
                                            <th>TAKE OFF ALT</th>
                                            <th>DEST ALT 1</th>
                                            <th>DEST ALT 2</th>
                                        </tr>
                                        <tr>
                                            <td>{dDate}</td>
                                            <td>{reg}</td>
                                            <td>{flt}</td>
                                            <td>{etd}</td>
                                            <td>{dIcao}</td>
                                            <td>{aIcao}</td>
                                            <td>{takeOff}</td>
                                            <td>{dest1}</td>
                                            <td>{dest2}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                        <tr className="align-bottom">
                            <th colSpan="10" className="w-100">METARs</th>
                        </tr>

                        <tr>
                            <th colSpan="2" className="w-20 text-right">DEPARTURE</th>
                            <td colSpan="8" className="w-80 text-left">{dep}</td>
                        </tr>

                        <tr>
                            <th colSpan="2" className="w-20 text-right">DESTINATION</th>
                            <td colSpan="8" className="w-80 text-left">{arr}</td>
                        </tr>

                        <tr>
                            <th colSpan="2" className="w-20 text-right">TAKE OFF ALT</th>
                            <td colSpan="8" className="w-80 text-left">{takeOffAlt}</td>
                        </tr>

                        <tr>
                            <th colSpan="2" className="w-20 text-right">DEST ALT 1</th>
                            <td colSpan="8" className="w-80 text-left">{destAlt1}</td>
                        </tr>

                        <tr>
                            <th colSpan="2" className="w-20 text-right">DEST ALT 2</th>
                            <td colSpan="8" className="w-80 text-left">{destAlt2}</td>
                        </tr>

                        <tr>
                            <td colSpan="10" className="w-100">
                                <table className="w-100 text-center table-layout-fixed">
                                    <tbody>
                                        <tr className="align-bottom">
                                            <th>ST TOW</th>
                                            <th>ST LW</th>
                                            <th>ST ZFW</th>

                                            <th rowSpan="2">TRIP FUEL</th>
                                            <th rowSpan="2">MIN DISPATCH FUEL</th>
                                            <th rowSpan="2">DEST HOLD</th>
                                            <th rowSpan="2">EXTRA</th>
                                            <th rowSpan="2">TOTAL FUEL UPLIFTED</th>
                                        </tr>
                                        <tr>
                                            <td>{stTow}</td>
                                            <td>{stLw}</td>
                                            <td>{stZfw}</td>
                                        </tr>
                                        <tr>
                                            <th className="align-bottom">OTOW</th>
                                            <th className="align-bottom">OLW</th>
                                            <th className="align-bottom">EZFW</th>

                                            <td rowSpan="2">{trip}</td>
                                            <td rowSpan="2">{minDisp}</td>
                                            <td rowSpan="2">{destHold}</td>
                                            <td rowSpan="2">{extraFuel}</td>
                                            <td rowSpan="2">{ramp}</td>
                                        </tr>
                                        <tr>
                                            <td>{otow}</td>
                                            <td>{olw}</td>
                                            <td>{ezfw}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                        <tr>
                            <th colSpan="2" className="w-20 text-right">CLOSURE</th>
                            <td colSpan="8" className="w-80 text-left text-prewrap">
                                {
                                    closure && closure.trim() ? closure.trim() : 'N/A'
                                }
                            </td>
                        </tr>

                        <tr>
                            <th colSpan="2" className="w-20 text-right">REMARKS</th>
                            <td colSpan="8" className="w-80 text-left text-prewrap">
                                {
                                    remark && remark.trim() ? remark.trim() : 'NIL'
                                }
                            </td>
                        </tr>

                        <tr>
                            <th colSpan="2" className="w-20 text-right">PERMIT</th>
                            <td colSpan="8" className="w-80 text-left text-prewrap">
                                {
                                    permit && permit.trim() ? permit.trim() : 'N/A'
                                }
                            </td>
                        </tr>

                        <tr>
                            <th colSpan="2" className="w-20 text-right">MEL/CDL</th>
                            <td colSpan="8" className="w-80 text-left">
                                <p className='text-prewrap'>
                                    {
                                        melcdl && melcdl.trim() ? melcdl.trim() : 'NIL'
                                    }
                                </p>
                            </td>
                        </tr>

                        <tr>
                            <td colSpan="10" className="w-100">
                                <table className="w-100 table-layout-fixed">
                                    {/* <thead>
                                        <tr>
                                            <th>Aerodoc</th>
                                            <th>Jeppesen</th>
                                            <th>OPT</th>
                                            <th>Spice Airdocs</th>
                                            <th>DDG</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="align-top text-prewrap">
                                            <td>{aerodoc}</td>
                                            <td>{jeppesen}</td>
                                            <td>{opt}</td>
                                            <td>{iqrh}</td>
                                            <td>{ddg}</td>
                                        </tr>
                                    </tbody> */}
                                    <thead>
                                        <tr>
                                            <th>Jeppesen</th>
                                            <th>OPT</th>
                                            <th>DDG</th>
                                            <th>Spice Airdocs</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="align-top text-prewrap">
                                            <td>{jeppesen}</td>
                                            <td>{opt}</td>
                                            <td>{ddg}</td>
                                            <td>{iqrh}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                        <tr className="text-center">
                            <td colSpan="7" className="w-70">
                                <ol className="text-left" style={{ paddingLeft: '1.5rem' }}>
                                    <li>I am legal to operate the flight as per FDTL regulations.</li>
                                    <li>EXPATS: My FATA license is valid and I am legal to operate as per CAR.</li>
                                    <li>I have read and understood all current Operations Circulars.</li>
                                    <li>I have read and understood the AERODROME SOPs relevant for may route(s) today.</li>
                                    <li>I acknowledge that "Supervised T/O, Landing" is PROHIBITED on CAT-C Airfields.</li>
                                    <li>I have read, understood and accepted the briefing package (CFP, NOTAM, MET, MEL/CDL
                                DOCUMENTs).</li>
                                    <li>I have read and understood contents of SOP on B737  temporary freight operations with passenger seats removed(As applicable) - Not applicable for Q400</li>
                                </ol>
                            </td>
                            <td colSpan="3" className="w-30 align-bottom bold">
                                <img className='border-0' src={sign} alt='' style={{ height: '5rem' }} /><br />
                                {name}<br />
                                (FLIGHT DISPATCHER)
                    </td>
                        </tr>

                        <tr>
                            <td colSpan="10" className="w-100">
                                <table className="w-100 text-center border-0 table-layout-fixed">
                                    <tbody>
                                        <tr>
                                            <td colSpan="5" className="w-50 align-bottom bold">
                                                <div style={{ marginTop: '2rem' }}>{capName}<br />(CAPTAIN's SIGNATURE)</div>
                                            </td>
                                            <td colSpan="5" className="w-50 align-bottom bold">
                                                <div style={{ marginTop: '2rem' }}>{foName}<br />(FIRST OFFICER's SIGNATURE)</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan="2" className="w-20 text-right">Licence &amp; Medical Valid</td>
                                            <td colSpan="3" className="w-30 text-left border-bottom"></td>
                                            <td colSpan="2" className="w-20 text-right">Licence &amp; Medical Valid</td>
                                            <td colSpan="3" className="w-30 text-left border-bottom"></td>
                                        </tr>
                                        <tr>
                                            <td colSpan="2" className="w-20 text-right">BA TEST NO</td>
                                            <td colSpan="3" className="w-30 text-left border-bottom"></td>
                                            <td colSpan="2" className="w-20 text-right">BA TEST NO</td>
                                            <td colSpan="3" className="w-30 text-left border-bottom"></td>
                                        </tr>
                                        <tr>
                                            <td colSpan="2" className="w-20 text-right">LICENCE/FATA NO</td>
                                            <td colSpan="3" className="w-30 text-left border-bottom"></td>
                                            <td colSpan="2" className="w-20 text-right">LICENCE/FATA NO</td>
                                            <td colSpan="3" className="w-30 text-left border-bottom"></td>
                                        </tr>
                                        <tr>
                                            <td colSpan="2" className="w-20 text-right">REPORTING TIME</td>
                                            <td colSpan="3" className="w-30 text-left border-bottom"></td>
                                            <td colSpan="2" className="w-20 text-right">REPORTING TIME</td>
                                            <td colSpan="3" className="w-30 text-left border-bottom"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>

                    <tfoot>
                        <tr>
                            <td colSpan="10" className="w-100 text-center border-0">
                                HAVE A SAFE FLIGHT!
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <div className="page break-before">
                <table className='w-100'>
                    <thead>
                        <tr>
                            <th className="text-center">
                                <h3>CAPTAIN'S POST FLIGHT DE-BRIEF REPORT</h3>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr className="align-top" style={{ height: '10rem' }}>
                            <td>1. RADIO / NAV AIDS / COMPANY VHF / COMPANY HF</td>
                        </tr>
                        <tr className="align-top" style={{ height: '10rem' }}>
                            <td>2. MET CONDITIONS</td>
                        </tr>
                        <tr className="align-top" style={{ height: '10rem' }}>
                            <td>3. RWY &amp; ROUTE / FLIGHT SAFETY RELATED</td>
                        </tr>
                        <tr className="align-top" style={{ height: '10rem' }}>
                            <td>4. OTHERS IF ANY</td>
                        </tr>
                        <tr>
                            <td>
                                <table className="w-100 border-0 text-left table-layout-fixed">
                                    <thead>
                                        <tr className="align-bottom" style={{ height: '8rem' }}>
                                            <td colSpan="2" className="w-100">SIGNATURE</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colSpan="1" className="w-50 border-bottom">CAPTAIN NAME</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="1" className="w-50 border-bottom">DATE</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="1" className="w-50 border-bottom">FLIGHT NO</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="1" className="w-50 border-bottom">SECTOR</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan="10" className="text-center">
                                PLEASE SUBMIT IN FLIGHT DISPATCH OFFICE FOR NECESSARY ACTION</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </>;
}

class Preview extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.save = this.save.bind(this);
    }

    componentDidMount() {
        const frameBody = ReactDOM.findDOMNode(this).contentDocument.body;
        this.el = document.createElement('div');
        frameBody.appendChild(this.el);
        const { general, alt, metar, weight, fuel, compFreq, mel, cdl, extra, efb, creator } = this.props;
        ReactDOM.render(<BriefingSheet data={{ general, alt, metar, weight, fuel, compFreq, mel, cdl, extra, efb, creator }} />, this.el);
    }

    save(e) {
        e.preventDefault();
        this.props.save(this.el.innerHTML);
    }

    render() {
        return <>
            <iframe
                title='preview'
                className='bg-light border-0 shadow'
                style={{ height: '96vh', width: '96vw', margin: '2vh 2vw', }}>
            </iframe>
            <div className='position-absolute w-100 text-center' style={{ top: '2px' }}>
                <button className='btn btn-sm btn-light border border-dark'
                    onClick={this.save}>
                    <i><FontAwesomeIcon icon={faSave} /></i> Save</button>
                <button className='btn btn-sm btn-light border border-dark ml-3'
                    onClick={e => {
                        e.preventDefault();
                        this.props.setPreview(false);
                    }}>
                    <i><FontAwesomeIcon icon={faTimes} /></i> Discard</button>
            </div>
            <div className='position-absolute w-100 text-center' style={{ bottom: '0.5rem' }}>
                <button className='btn btn-sm btn-light border border-dark'
                    onClick={this.save}>
                    <i><FontAwesomeIcon icon={faSave} /></i> Save</button>
                <button className='btn btn-sm btn-light border border-dark ml-3'
                    onClick={e => {
                        e.preventDefault();
                        this.props.setPreview(false);
                    }}>
                    <i><FontAwesomeIcon icon={faTimes} /></i> Discard</button>
            </div>
        </>;
    }
};

export default Preview;